import Vue from 'vue';
import Snotify, { SnotifyPosition } from 'vue-snotify';

const snotifyOptions = {
    toast: {
        position: SnotifyPosition.rightTop,
        timeout: 5000
    }
};
Vue.use(Snotify, snotifyOptions);
